// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1genj","colMin":"styles_colMin__30hL7","colCheckbox":"styles_colCheckbox__1kV5b"};